import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=64cf15a3"
import script from "./DataFilter.vue?vue&type=script&lang=js"
export * from "./DataFilter.vue?vue&type=script&lang=js"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=64cf15a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports